// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__p0o68","input_text":"TextInput_input_text__u58H7","active":"TextInput_active__5bk+2"};